import { useEffect, useState } from "react";
import PermissionsTable from "../PermissionsTable";
import { getPermissions } from "../../../../../scripts/permission";
import { loadingStates } from "../../../../installation/installationTypes";
import { permissionTableTypes } from "../userAdministrationUtils";
import LoadDataContainer, { loadDataHandler } from "../../../../UiComponents/containers/LoadDataContainer";

const UserPermissionsTable = ({ venues, user, setViewState, permissionTableRef, refreshUsers }) => {
    const [permissions, setPermissions] = useState();
    const [loadingState, setLoadingState] = useState(loadingStates.NONE);
    const [users, setUsers] = useState([user]);

    useEffect(() => {
        loadDataHandler(getData, setLoadingState)
    }, [user.userId]);

    const getData = async () => {
        const permissionsRes = await getPermissions(null, user.userId);
        setPermissions(permissionsRes);
        setUsers([user]);
        return permissionsRes;
    }

    return <>
        <LoadDataContainer loadingState={loadingState}>
            {venues && permissions ? <>
                <PermissionsTable
                    tableType={permissionTableTypes.user}
                    venues={venues}
                    users={users}
                    originalPermissions={permissions}
                    refresh={getData}
                    permissionTableRef={permissionTableRef}
                    setViewState={setViewState}
                    refreshUsers={refreshUsers}
                />
            </> : <></>}
        </LoadDataContainer>
    </>
}

export default UserPermissionsTable;

